import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { getAll } from 'Config/lang';
import {
  LANGUAGE_MODAL,
  toggleLanguageModal,
} from 'Redux/ducks/modal';
import LazyModal from 'Components/Behaviour/LazyLoading/LazyModal';

const LanguagePickerModal = lazy(() => import(/* webpackChunkName: "LanguagePickerModal" */ 'Components/Modal/LanguageModal/LanguagePickerModal'));

const LanguageModalContainer = ({ hideCaret, buttonText }) => {
  const dispatch = useDispatch();
  const isModalOpen = useSelector(state => state.modal[LANGUAGE_MODAL]);
  const { pathname, search } = useSelector(state => state.router.location);

  const languages = getAll();

  if (languages.length < 2 || pathname.startsWith('/blog')) {
    return null;
  }

  const isProductPage = !!pathname.match(/^\/(game|bundle|dlc|book|comic|audio|video|software)\//);

  const countryData = window.countryData || {};
  const hasNativePrice = countryData['Native-Currency-Alphabetic-Code'] && countryData['Native-Currency-Alphabetic-Code'] !== countryData['Currency-Alphabetic-Code'];
  return (
    <React.Fragment>
      <Button
        color="link"
        className="btn-language language-modal-button"
        onClick={() => dispatch(toggleLanguageModal())}
      >
        <div>
          {buttonText || <FormattedMessage
            id="languagemodal.buttontext"
            defaultMessage="Language"
          />}
          {hasNativePrice &&
            <span>
              <span>{' / '}</span>
              <FormattedMessage
                id="languagemodal.currencybuttontext"
                defaultMessage="Currency"
              />
            </span>
          }
        </div>
        {!hideCaret &&
          <FontAwesomeIcon icon={faChevronRight} />
        }
      </Button>
      <LazyModal
        open={isModalOpen}
        setOpen={() => dispatch(toggleLanguageModal())}
        className="account-modal"
      >
        <LanguagePickerModal />
      </LazyModal>
      <ul className="d-none">
        {languages.filter(language => language.code !== window.locale).map(language =>
          <li key={language.code}><a href={`/${language.code}${pathname}${isProductPage ? '' : search}`}>{language.nativeLabel}</a></li>,
        )}
      </ul>
    </React.Fragment>
  );
};


LanguageModalContainer.propTypes = {
  hideCaret: PropTypes.bool,
  buttonText: PropTypes.string,
};

LanguageModalContainer.defaultProps = {
  hideCaret: false,
  buttonText: null,
};


export default LanguageModalContainer;
